import { EvtEmployeeCard } from "components/employee/display-card";
import React from "react";

const EmployeeSection = ({ title, employee, cardContent, href, className }) => {
  return (
    <div className={className}>
      <h3 className="mb-2 text-muted-foreground">{title}</h3>
      <EvtEmployeeCard user={employee} cardContent={cardContent} href={href} />
    </div>
  );
};

export default EmployeeSection;
